<template>
	<div class="about">
		<!-- top -->
		<div class="top"></div>
		<div class="content">
            <div class="discribe">更安全，三方互评远离黑中介；更便捷，地理GIS同城推荐，推荐更合适的灵工者给企业；更迅速，解决单个供应商招工难，上岗率低的痛点。更安全，三方互评远离黑中介；更便捷，地理GIS同城推荐，推荐更合适的灵工者给企业；更迅速，解决单个供应商招工难，上岗率低的痛点。更安全，三方互评远离黑中介；更便捷，地理GIS同城推荐，推荐更合适的灵工者给企业；更迅速，解决单个供应商招工难，上岗率低的痛点。</div>
            <div class="cardlist">
                <div class="card">
                    <div>
                        <p>总部地址</p>
                        <p>湖南省长沙市天心区中信广场</p>
                    </div>
                </div>
                <div class="card">
                       <div>
                        <p>客服热线</p>
                        <p>0731-12341234</p>
                    </div>
                </div>
                <div class="card">
                      <div>
                        <p>商务合作</p>
                        <p>7601231231@163.com</p>
                    </div>
                </div>
            </div>
        </div>
<!--		<Map></Map>-->
	</div>
</template>

<script>
	// import Footer from "@/components/layout/footer";
	import Map from "@/components/Map";
	export default {
		components: {
			// Footer,
			// Map
		},
		data() {
			return {

			}
		},
	};
</script>

<style lang="scss" scoped>
	.map {
		width: 65%;
		height: 550px;
		margin: 0 auto;
		background-color: #eee;
	}

	.about {
		padding-top: 80px;
		width: 100%;

		.top {
			width: 100%;
			background-image: url("./../static/image/bg_img/aboutBg.png");
			height: 22vh;
			background-size: 100%;
			background-repeat: no-repeat;
		}

		.content {
			padding-top: 10vh;
			padding-bottom: 100px;
			width: 65%;
			margin: 0 auto;
			.discribe {
				font-size: 24px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #474747;
				line-height: 42px;
				text-align: justify;
			}

			.cardlist {
				display: flex;
				justify-content: space-between;
				margin-top: 80px;

				.card {
					box-shadow: 5px 0 5px rgba(0, 0, 0, 0.2);
					width: 32%;
					height: 180px;
					div {
						padding: 50px 0 0 5vw;
						text-align: left;
						p:nth-child(1) {
							font-size: 18px;
							color: #000000;
							font-weight: 700;
							line-height: 28px;
						}
						p:nth-child(2) {
							margin-top: 5px;
							font-size: 16px;
							color: #000000;
							line-height: 22px;
						}
					}
				}
				.card:nth-child(1) {
					background-image: url("../static/image/bg_img/about_card_one.png");
					background-size: 100%;
					background-repeat: no-repeat;
				}

				.card:nth-child(2) {
					background-image: url("../static/image/bg_img/about_card_two.png");
					background-size: 100%;
					background-repeat: no-repeat;
				}

				.card:nth-child(3) {
					background-image: url("../static/image/bg_img/about_card_three.png");
					background-size: 100%;
					background-repeat: no-repeat;
				}
			}
		}
	}
</style>
